import { Injectable } from '@angular/core';
import { Employee } from './employee.model';
import { HWCInfo, TillDrawer } from './HWCInfo.model';

@Injectable({
    providedIn: 'root'
})
export class SessionContext {
    public BranchId: number = -1;
    public BranchUId: string = "";
    public TerminalId: number = -1;
    public EmployeeId: number = -1;
    public CustomerName: string = "";
    public Employee: Employee = null;
    public TerminalName: string = "";

    public HasHWC: boolean = false;
    public HasHWCConnected: boolean = false;
    public HWCInfo: HWCInfo = null;
    public CanEditQueue: boolean = false;
    public TerminalIP: string = "";
    public TerminalTillDrawerId: number = -1;

    // TillDrawerList: TillDrawer[] = [];

    constructor() {
    }
}
